webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(49)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(31),
  /* template */
  __webpack_require__(83),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Banner__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Banner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Banner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_About__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Course__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Course___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Course__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Registration__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Registration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Registration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Staff__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Staff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Staff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Exp__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Exp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Exp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Coc__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Coc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Coc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Footer__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Admission__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Admission___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Admission__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Organizer__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Organizer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Organizer__);













Element.prototype.addClass = function (classNames) {
  var classList = this.className.split(' ').filter(function (className) {
    return className.length > 0;
  });
  var addClassList = classNames.split(' ').filter(function (className) {
    return classList.indexOf(className) < 0;
  });
  this.className = classList.concat(addClassList).join(' ');
};

Element.prototype.removeClass = function (classNames) {
  var classList = this.className.split(' ').filter(function (className) {
    return className.length > 0;
  });
  var removeClassList = classNames.split(' ');
  classList = classList.filter(function (className) {
    return removeClassList.indexOf(className) < 0;
  });
  if (classList.length > 0) {
    this.className = classList.join(' ');
  } else {
    this.removeAttribute('class');
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Banner: __WEBPACK_IMPORTED_MODULE_0__components_Banner___default.a,
    About: __WEBPACK_IMPORTED_MODULE_1__components_About___default.a,
    Course: __WEBPACK_IMPORTED_MODULE_2__components_Course___default.a,
    Registration: __WEBPACK_IMPORTED_MODULE_3__components_Registration___default.a,
    Staff: __WEBPACK_IMPORTED_MODULE_4__components_Staff___default.a,
    Exp: __WEBPACK_IMPORTED_MODULE_5__components_Exp___default.a,
    Coc: __WEBPACK_IMPORTED_MODULE_6__components_Coc___default.a,
    Footers: __WEBPACK_IMPORTED_MODULE_7__components_Footer___default.a,
    Admission: __WEBPACK_IMPORTED_MODULE_8__components_Admission___default.a,
    Organizer: __WEBPACK_IMPORTED_MODULE_9__components_Organizer___default.a
  }
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'About'
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Admission',
  data: function data() {
    return {
      admissionList: ['郭Ｏ弘', '謝Ｏ燁', '曹Ｏ翔', '蘇Ｏ瑄', '洪Ｏ瑜', '陳Ｏ佑', '楊Ｏ文', '王Ｏ翔', '王Ｏ華', '張Ｏ勛', '賈Ｏ郁', '廖Ｏ安', '雲Ｏ仁', '呂Ｏ霆', '洪Ｏ哲', '卓Ｏ嘉', '盧Ｏ宇', '王Ｏ鈞', '陳Ｏ靜', '黃Ｏ鈞', '羅Ｏ晴', '張Ｏ愷', '詹Ｏ翔', '許Ｏ駿', '陳Ｏ智', '張Ｏ遠', '孫Ｏ均', '歐Ｏ詮', '黃Ｏ軒', '盧Ｏ達', '朱Ｏ鵬', '蔡Ｏ霖', '李Ｏ樺', '王Ｏ涵', '李Ｏ皜', '劉Ｏ婕', '郭Ｏ瑄', '于Ｏ', '陳Ｏ', '李Ｏ霆', '張Ｏ程', '呂Ｏ瑀', '劉Ｏ龍', '林Ｏ瑄', '嚴Ｏ', '林Ｏ萱', '吳Ｏ緯', '干Ｏ軍', '陳Ｏ彰', '黃Ｏ鵬', '胡Ｏ瑜', '黃Ｏ蘋', '練Ｏ杉', '牟Ｏ佑', '鄒Ｏ權', '陳Ｏ達', '王Ｏ翔', '曾Ｏ倢', '周Ｏ毅', '蘇Ｏ銘'],
      waiting: ['朱Ｏ暉', '謝Ｏ宥', '許Ｏ誠', '黃Ｏ涵', '羅Ｏ宗', '干Ｏ丞', '江Ｏ奇', '徐Ｏ凌']
    };
  }
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Navbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jump_js__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Banner',
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_0__Navbar___default.a
  },
  methods: {
    admission: function admission() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_jump_js__["a" /* default */])('#admission');
    }
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'coc'
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Fancybox__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Fancybox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Fancybox__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Course',
  components: {
    Fancybox: __WEBPACK_IMPORTED_MODULE_0__Fancybox___default.a
  },
  data: function data() {
    return {
      courses: [{
        title: 'Python 3',
        subTitle: '魔法師之路 I',
        speakers: [{
          name: '維尼',
          introduction: '台灣教育體制的逃兵'
        }],
        introduction: 'Python 介紹特性及安裝\n資料型態\n程式流程控制\n函數自定義及使用\n常用函式庫介紹及安裝'
      }, {
        title: 'HTTP、RESTful 觀念與實作',
        subTitle: '神秘的修業',
        speakers: [{
          name: 'Denny Huang',
          introduction: 'SITCON 學生計算機年會共同發起人，2013 及 2014 年會總召，目前於雷亞遊戲（Rayark Inc.）擔任遊戲後端工程師；在正規教育中特例獨行，妄想透過改善教育讓台灣更進步，崇尚開源精神，熱愛使用者界面 (UI) 以外的多種技術。'
        }],
        introduction: '每天你在手機滑著 Facebook App，又或是在電腦上打開瀏覽器逛著各種網頁，你是否有想過這些內容是如何呈現在你的眼前？聽到伺服器這個詞，你想到了什麼？架伺服器真的有這麼困難？到底伺服器要做什麼事情？這堂課程將帶你看透一切，過去對你來說或許是黑魔法的未知領域，在課程過後相信你對世界會有嶄新的看法！'
      }, {
        title: 'Python3 × HTTP',
        subTitle: '魔法師之路 II',
        speakers: [{
          name: '維尼',
          introduction: '台灣教育體制的逃兵'
        }],
        introduction: '如何閱讀函式庫官方文件\n找出臭蟲(DEBUG)'
      }, {
        title: '開源社群精神',
        subTitle: '源力之美',
        speakers: [{
          name: '陳立函 nfsnfs',
          introduction: '化工學士與資工碩士、博士，目前於工研院資通所服務，平時會參與或籌辦 COSCUP、openSUSE.zh_TW與 g0v summit 的活動，open source 志工，平時研究領域包括作業系統、資訊安全與行動安全。'
        }],
        introduction: '在這個簡短的 talk，講者會帶大家了解開源是什麼？什麼是自由軟體？身為一個躍躍欲試的新手，又該怎麼參與開源活動，能幫上什麼忙呢？並分享講者自己從一般參與者到擔任 COSCUP 2016 行政組長的心得和經驗。'
      }, {
        title: 'Telegram Chatbot',
        subTitle: '尼斯的手冊',
        speakers: [{
          name: '倪鈵斯',
          introduction: '即將從台科大資管系畢業。因對從小到大對地理有興趣所以大學以後很開心的選修了地理系的課，沒想到到了地理系卻寫了更多的程式。目前專注於GPU平行加速應用在地理資料空間運算上。\n曾經在數個課程中擔任Python程式助教（DSP智庫驅動資料工程師課程、台科大程式設計研究社等）；設計過「魯蛇」聊天機器人。'
        }, {
          name: '助教 － 楊景翔',
          introduction: '講師邀請教學經驗豐富的景翔同學協助課程的開發。他曾經在台科大程式設計研究社中擔任Javascript講師；目前正在「橘子蘋果兒童程式學苑」設計國中小學生也能學習的程式設計教材，他同時也是該課程的種子教師。'
        }],
        introduction: '你對於聊天機器人有什麼想像呢？ 你希望機器人可以提醒你接下來的行程、提供你有用的生活資訊、讓你跟你的朋友們一起進行機智問答；或者是像人類一樣的進行對話？前三項，我們將它稱之為任務型機器人；最後一項，則稱之為會話型機器人。  在正式課程之前，講師會先針對以上兩種機器人進行非常簡單的介紹，並在後續課程中以任務型機器人為主軸，指導大家如何閱讀Telegram API文件，動手設計一個可以收發訊息、提供按鈕等互動的機器人。'
      }, {
        title: '網頁（前端）是什麼',
        subTitle: '突如其來的訪客',
        speakers: [{
          name: 'Zorro',
          introduction: 'Zorro ，社群人稱小馬，是個原本是個麵包師父，後來半路出家成為野生的前端工程師'
        }],
        introduction: '何謂前端? 為什麼我需要懂前端?\n現代前端網頁前端三兄弟 (HTML、CSS、JavaScript ) 與他們眾多的的快樂夥伴們 (Jade SCSS React ..etc)'
      }, {
        title: '資訊安全',
        subTitle: '與黑魔法師的約會',
        speakers: [{
          name: 'HrJ',
          introduction: '台灣校園間最大的資訊安全社群 TDOHacker 的創辦人兼現任萬年總召，平常遊走於各校園中致力於推廣資訊安全、培育資安人才與輔導校園資安社群。目前於與夥伴創立的資安新創公司 Leukocyte-Lab 擔任COO。'
        }],
        introduction: '每日身處於資訊社會，我們卻時常不知生活上的資安風險為何。本場講座將以生活中常見的資安風險為主題來簡單介紹如何在資訊海洋中保護自己，同時介紹相關資安社群與學習資源，期望讓學生們皆能具備具備簡單的個人資安防護知識。'
      }, {
        title: 'SITCON 2017 論壇系統',
        subTitle: '遙遠的記憶',
        speakers: [{
          name: 'Jeremy Yen',
          introduction: '從高中開始接觸網頁與程式設計，曾參加過資訊能力競賽，喜愛嘗試新技術、接觸不同領域的人，也熱愛閱讀和旅行。大學時曾在一家中小企業開發過企業資安軟體，也曾在 KPMG 顧問部門實習。不過最後還是發現自己比較喜歡 Coding，所以目前在 Glossika 萬語科技擔任 Full Stack Developer。'
        }],
        introduction: '短講中將分享我和 PCC 開發 SITCON 2017 論壇發言系統的過程，內容將涵蓋事前規劃，需求發想和確認，以及選用技術的考量，開發、協作時遇到的問題，以及最後上線前的測試和準備。如果有足夠時間也會順便提及一些技術上該注意的細節。'
      }, {
        title: 'AI',
        subTitle: '最後的魔法',
        speakers: [{
          name: '陳哲雋（阿哲）',
          introduction: '爆肝中的耍廢研究生，主要研究領域是資訊教育，另外有許多<del>不務正業</del>業餘的愛好\n對於推廣資訊領域有相當熱忱，也喜歡和大家交流'
        }],
        introduction: '人工智慧已成為現今最熱門話題之一，到底什麼才算是人工智慧？人工智慧有哪些方法？如何入門？\n演講將藉由講者大學專題製作格鬥遊戲人工智慧並參與比賽之經驗，說明人工智慧要如何入門以及相關技術或方法'
      }],
      boxContent: {
        title: '',
        subTitle: '',
        speaker: {
          name: '',
          introduction: ''
        },
        introduction: '',
        active: false
      },
      theWorldCafe: {
        title: '視界咖啡館',
        subTitle: '傳承',
        speakers: [{
          name: 'CIH',
          introduction: '深曉台灣與山林之美，步行環台55天1200公里，用眼睛錄下台灣之美。享受探險的箇中樂趣。\n創辦回憶app：8tory。\n專長用戶行為分析、資料的探勘與解析。'
        }, {
          name: '林裕欽（Kytu）',
          introduction: '現任 Dcard CEO 暨 Co-Founder。於台灣大學資訊管理學系畢業，就學時期曾參加台大創新創意學程，並擔任 NTU design Thinking 社長及參與 NTU Consulting Club 創立。並曾在台大資工系課程擔任助教、代表國家擔任外交部青年大使出訪加拿大、參與商業競賽 ATCC 獲得研華組冠軍，在技術及商業上都有相當的敏銳度。大二與其學長共同創辦 Dcard。Dcard 於 2015 年正式成立公司，不僅創造了所有人都能放心做自己的平台，也給熱愛挑戰的人才一個發揮與自我實現的舞台。'
        }, {
          name: 'Max Wu',
          introduction: '已知如何敲鍵盤，快從研究所畢業，準備當替代役。\n現任 HackMD Lead。'
        }, {
          name: '呂行 Shing Lyu',
          introduction: '現任 Mozilla 資深軟體工程師，長期投入 open source 社群，目前主攻瀏覽器與 Web 技術。涉獵領域甚廣，從軟體測試、機器學習、電腦音樂、Frontend、Backend、演算法交易皆有相當經驗。\nhttps://shinglyu.github.io/'
        }, {
          name: '',
          introduction: '講師順序係依英文順序排序'
        }],
        introduction: '視界咖啡館參考自世界咖啡館（The World Café），在本次夏令營中，我們邀請到各領域及社群前輩，將傳統座談會形式改以小組討論的樣貌呈現，並與學員分享工作經驗、學習過程、面對困難的解決方式或希望給予 SITCON 夏令營學員的建議，提出值得學員思考、了解的觀點。期望透過縮短講師及學員間的距離，鼓勵學員踴躍提問、參與，進而產生良好的雙向交流。'
      },
      showFancyBox: false,
      showCommunity: false,
      showTheWorldCafe: false
    };
  },

  computed: {
    communities: function communities() {
      return [{
        name: 'Fedora 台灣',
        img: 'fedora-tw.png',
        introduction: 'Fedora 臺灣社群最早的起源是從 Red Hat Linux 臺灣社群延續而來，自 2003 年 Fedora Linux 發佈後轉為 Fedora 臺灣社群。Fedora 臺灣社群前期主要以網路論壇上的互動為主，較少實體活動；自 2011 年起，陸續有社群朋友申請成為官方認可的 Fedora 大使，除了推廣 Fedora 並舉辦相關活動外，也積極打造更友善的社群參與環境。\nFedora 專案的宗旨在於打造人人可以自由使用並分享的作業系統，但自由的作業系統有賴各種自由軟體才能建構而成，因此 Fedora 臺灣社群除了推廣 Fedora 外，也推廣各項自由軟體。目前為止曾與 Fedora 臺灣社群一同合作、舉辦活動的社群包括 GNOME 臺灣 (GNOME 3 Release Party)、LibreOffice 臺灣 (COSCUP 攤位共同展示)、Mozilla 臺灣 (FF 18 Release Party)… 等，也歡迎各自由軟體社群與 Fedora 臺灣合作，一起攜手開創臺灣自由軟體社群的未來。'
      }, {
        name: 'g0v',
        img: 'g0v_logo.png',
        introduction: 'g0v.tw 是一個推動資訊透明化的社群，致力於開發公民參與社會的資訊平台與工具。\n將 gov 以「零」替代成為 g0v，從零重新思考政府的角色，也是代表數位原生世代從 0 與 1 世界的視野。g0v.tw 以開放原始碼的精神為基底，關心言論自由、資訊開放，寫程式提供公民容易使用的資訊服務。資訊的透明化能幫助公民更確實了解政府運作、更快速了解議題，不被媒體壟斷，也才可有效監督政府，化為參與行動最終深化民主體質。'
      }, {
        name: 'Hadoop.TW',
        img: 'hadoop.tw.jpg',
        introduction: 'Hadoop.TW 於 2008年8月由台灣雅虎成立，初期僅以網站方式分享 Hadoop 相關技術文章。後期則由國網中心提供 http://forum.hadoop.tw 技術討論區與 http://hadoop.nchc.org.tw 實驗叢集(2009/04/13 開放服務，2014/03/31 終止服務)。\n目前主要的社群活動包括：臉書粉絲團、社群靜態網站、討論區、教學資源 、年會網站與不定期舉辦的工作坊(Workshop)。'
      }, {
        name: 'HITCON (台灣駭客年會 Hacks In Taiwan Conference)',
        img: 'hitcon.png',
        introduction: 'HITCON 台灣駭客年會發起自 2005 年，是台灣最大的駭客與資安技術研討會。從 2014 年開始更分為兩個場次：HITCON Enterprise 以及 HITCON Community，期望可以滿足不同聽眾的各種需求。\n台灣駭客年會提供了一個舞台讓駭客們有機會與大家分享最新與最深入的資安技術，面對面交流經驗，自由的對談。'
      }, {
        name: 'HITCON GIRLS',
        img: 'hitcon-girls.png',
        introduction: 'HITCON GIRLS 是以女性為主的資安社群。希望聚集對資安感興趣、願意深入學習的女性，共同加入團隊探討知識與技術，推廣「大家都能學習資安！」的理念。我們相信學習的過程中一定會有許多瓶頸，而克服問題需要勇氣，藉由讀書會合作克服問題和找到分享的勇氣，提供一個安心學習的環境。'
      }, {
        name: 'MozTW',
        img: 'moztw.png',
        introduction: 'MozTW 是台灣專注於貢獻 Mozilla 相關議題的社群，於 2004 年 9 月成立。目前負責維護 Mozilla 軟體的正體中文版本與語言套件、使用者支援文件，並於 MozTW.org 網站提供軟體下載、新聞資訊與討論區等服務。\n自 2014 年初，MozTW 社群開始設立實體空間「摩茲工寮」，目前座落於台北光華商圈，歡迎各自由文化社群與專案免費使用。'
      }, {
        name: 'TDOHacker',
        img: 'tdoh.png',
        introduction: 'TDOHacker 成立於2013年，為一個校園取向的資訊安全社群組織。由一群對資安極具熱情的學生們組成，期望用社群的力量來推廣資訊安全、增加技術交流、改善台灣資安學習環境。自成立以來持續耕耘台灣資安人才培育環境，在全國各地與多所大專院校合作推廣資訊安全，是台灣第一大的校園資安社群。\n數年來舉辦數十場講座，協助多個社團與教育單位舉辦各項活動，完成多個資安教育平台專案。2016 年開始舉辦 TDOH PIPE、Conf 等大型活動，致力打造更完善的資安學習環境。'
      }, {
        name: '逢甲黑客社',
        img: 'hackersir.tw.png',
        introduction: '黑客社是由一群喜歡資訊安全的人們所創立，因緣際會之下成立了這個社團。\n我們致力推廣「資訊安全」及「程式設計」，秉持著「創新與實作」的理念， 除了推廣資訊安全的基礎概念、程式設計普及化、開源文化， 希望可以讓每位社員甚至每位學生都能了解到資安的重要性及體驗到更加便利、有趣的未來！'
      }].map(function (el) {
        el.introduction = el.introduction.split('\n');
        return el;
      });
    }
  },
  methods: {
    showLightBox: function showLightBox(e, index) {
      if (index < this.courses.length) {
        var course = this.courses[index];
        this.boxContent.title = course.title;
        this.boxContent.subTitle = course.subTitle;
        this.boxContent.speakers = course.speakers;
        this.boxContent.introduction = course.introduction.split('\n');
        this.showFancyBox = true;
      }
    }
  },
  watch: {
    showFancyBox: function showFancyBox(newValue, oldValue) {
      if (newValue !== oldValue) {
        window.document.body.classList.toggle('isShowFancyBox');
      }
    }
  }
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Exp'

});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'fancyBox'
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'footers'
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jump_js__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Navbar',
  data: function data() {
    return {
      section: ['banner', 'about', 'course', 'registration', 'staff', 'exp', 'coc'],
      clientHeight: document.documentElement.clientHeight || document.body.clientHeight,
      activatedMenu: false
    };
  },

  computed: {
    navbarHeight: function navbarHeight() {
      return this.$el.clientHeight;
    }
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.scroll);
  },

  methods: {
    scroll: function scroll(e) {
      var distant = document.getElementById('banner').getBoundingClientRect().top;
      if (distant <= -15) {
        this.$el.addClass('scrolled');
      } else {
        this.$el.removeClass('scrolled');
      }
    },
    jumpTo: function jumpTo(e) {
      e.preventDefault();
      var target = e.target.getAttribute('data-target');
      var isMobileView = window.innerWidth <= 500;
      if (isMobileView) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_jump_js__["a" /* default */])(target, {
          offset: -30
        });
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_jump_js__["a" /* default */])(target, {
          offset: -this.navbarHeight
        });
      }
      this.$el.querySelector('ul').removeClass('active');
      this.$el.removeClass('active');
      this.activatedMenu = false;
    },
    toggleMenu: function toggleMenu() {
      this.activatedMenu = !this.activatedMenu;
      if (this.activatedMenu) {
        this.$el.querySelector('ul').addClass('active');
        this.$el.addClass('active');
      } else {
        this.$el.querySelector('ul').removeClass('active');
        this.$el.removeClass('active');
      }
    }
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'organizer'
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Registration'
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Staff',
  data: function data() {
    return {
      staffs: []
    };
  },
  mounted: function mounted() {
    var self = this;
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('./static/staff.json').then(function (res) {
      self.staffs = res.data;
    });
  }
});

/***/ }),
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 56 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 57 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 59 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(57)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(32),
  /* template */
  __webpack_require__(89),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(51)
__webpack_require__(50)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(84),
  /* scopeId */
  "data-v-284c8d47",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(53)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(86),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(58)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(35),
  /* template */
  __webpack_require__(90),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(47)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(81),
  /* scopeId */
  "data-v-1961dfcd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(52)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(37),
  /* template */
  __webpack_require__(85),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(48)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(38),
  /* template */
  __webpack_require__(82),
  /* scopeId */
  "data-v-1c734414",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(54)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(39),
  /* template */
  __webpack_require__(87),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(59)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(91),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(46)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(80),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(56)
__webpack_require__(55)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(88),
  /* scopeId */
  "data-v-516b8deb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(60)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(92),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container",
    attrs: {
      "id": "organizer"
    }
  }, [_c('h1', {
    staticClass: "title fourtitle"
  }, [_vm._v("共同主辦")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://sitcon.org/2017/",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(67),
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', [_vm._v("SITCON 學生計算機年會")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://ocf.tw/",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(64),
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', [_vm._v("開放文化基金會")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://www.cs.thu.edu.tw/",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(65),
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', [_vm._v("東海大學 資訊工程學系")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://itservice.thu.edu.tw/",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(66),
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', [_vm._v("東海大學 電子計算機中心")])])])])])
}]}

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container",
    attrs: {
      "id": "course"
    }
  }, [_c('h1', {
    staticClass: "title twotitle"
  }, [_vm._v("課程")]), _vm._v(" "), _c('table', {
    attrs: {
      "id": "timetable"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('td', {
    staticClass: "cursor course",
    attrs: {
      "rowspan": "5"
    },
    on: {
      "click": function($event) {
        _vm.showLightBox($event, 1)
      }
    }
  }, [_c('p', [_vm._v("神秘的修業")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("\n            HTTP、RESTful 觀念與實作\n          ")])]), _vm._v(" "), _c('td', {
    staticClass: "activity cursor",
    attrs: {
      "rowspan": "5"
    },
    on: {
      "click": function($event) {
        _vm.showTheWorldCafe = true
      }
    }
  }, [_c('p', [_vm._v("傳承")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("\n            視界咖啡館\n          ")])]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('tr', [_vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('td', {
    staticClass: "cursor course",
    on: {
      "click": function($event) {
        _vm.showLightBox($event, 7)
      }
    }
  }, [_c('p', [_vm._v("遙遠的記憶")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("SITCON 2017 論壇系統")])])]), _vm._v(" "), _c('tr', [_vm._m(11), _vm._v(" "), _c('td', {
    staticClass: "cursor course",
    on: {
      "click": function($event) {
        _vm.showLightBox($event, 8)
      }
    }
  }, [_c('p', [_vm._v("最後的魔法")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("AI")])])]), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('tr', [_vm._m(13), _vm._v(" "), _c('td', {
    staticClass: "cursor course",
    attrs: {
      "rowspan": "2"
    },
    on: {
      "click": function($event) {
        _vm.showLightBox($event, 0)
      }
    }
  }, [_c('p', [_vm._v("魔法師之路")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("Python 3")])]), _vm._v(" "), _c('td', {
    staticClass: "cursor course",
    attrs: {
      "rowspan": "2"
    },
    on: {
      "click": function($event) {
        _vm.showLightBox($event, 2)
      }
    }
  }, [_c('p', [_vm._v("魔法師之路 II")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("Python 3 × HTTP")])]), _vm._v(" "), _c('td', {
    staticClass: "cursor course",
    attrs: {
      "rowspan": "2"
    },
    on: {
      "click": function($event) {
        _vm.showLightBox($event, 4)
      }
    }
  }, [_c('p', [_vm._v("尼斯的手冊")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("Telegram Chatbot")])]), _vm._v(" "), _vm._m(14)]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('tr', [_vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('td', {
    staticClass: "cursor course",
    on: {
      "click": function($event) {
        _vm.showLightBox($event, 3)
      }
    }
  }, [_c('p', [_vm._v("源力之美")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("開源社群精神")])]), _vm._v(" "), _c('td', {
    staticClass: "cursor course",
    attrs: {
      "rowspan": "2"
    },
    on: {
      "click": function($event) {
        _vm.showLightBox($event, 5)
      }
    }
  }, [_c('p', [_vm._v("突如其來的訪客")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("網頁（前端）是什麼")])])]), _vm._v(" "), _c('tr', [_vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('td', {
    staticClass: "activity cursor",
    attrs: {
      "rowspan": "4"
    },
    on: {
      "click": function($event) {
        _vm.showCommunity = true
      }
    }
  }, [_c('p', [_vm._v("魔法師的宴會")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("晚餐＆社群闖關")])]), _vm._v(" "), _vm._m(20)]), _vm._v(" "), _c('tr', [_vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('td', {
    staticClass: "cursor course",
    on: {
      "click": function($event) {
        _vm.showLightBox($event, 6)
      }
    }
  }, [_c('p', [_vm._v("與黑魔法師的約會")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("資訊安全")])])]), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25)])]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle bluecar"
  }, [_vm._v("廣度課程與短講")]), _vm._v(" "), _vm._m(26), _vm._v(" "), _c('h2', {
    staticClass: "subtitle redcar"
  }, [_vm._v("社群闖關")]), _vm._v(" "), _vm._m(27), _vm._v(" "), _c('h2', {
    staticClass: "subtitle bluecar"
  }, [_vm._v("視界咖啡館")]), _vm._v(" "), _vm._m(28), _vm._v(" "), _c('h2', {
    staticClass: "subtitle redcar"
  }, [_vm._v("Hackathon")]), _vm._v(" "), _vm._m(29), _vm._v(" "), (_vm.showFancyBox) ? _c('Fancybox', {
    on: {
      "close": function($event) {
        _vm.showFancyBox = false
      }
    }
  }, [_c('div', {
    staticClass: "btn-close",
    on: {
      "click": function($event) {
        _vm.showFancyBox = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.boxContent.title))]), _vm._v(" "), _vm._l((_vm.boxContent.introduction), function(paragraph, index) {
    return _c('p', {
      key: index,
      staticClass: "content"
    }, [_vm._v(_vm._s(paragraph))])
  }), _vm._v(" "), _vm._l((_vm.boxContent.speakers), function(speaker, index) {
    return _c('div', {
      key: index
    }, [_c('h2', {
      staticClass: "subtTitle"
    }, [_vm._v(_vm._s(speaker.name))]), _vm._v(" "), _c('p', {
      staticClass: "content"
    }, [_vm._v(_vm._s(speaker.introduction))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.showTheWorldCafe) ? _c('Fancybox', {
    on: {
      "close": function($event) {
        _vm.showTheWorldCafe = false
      }
    }
  }, [_c('div', {
    staticClass: "btn-close",
    on: {
      "click": function($event) {
        _vm.showTheWorldCafe = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.theWorldCafe.title))]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.theWorldCafe.introduction))]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("邀請講者")]), _vm._v(" "), _vm._l((_vm.theWorldCafe.speakers), function(speaker, index) {
    return _c('div', {
      key: index
    }, [_c('h2', {
      staticClass: "subtTitle"
    }, [_vm._v(_vm._s(speaker.name))]), _vm._v(" "), _c('p', {
      staticClass: "content"
    }, [_vm._v(_vm._s(speaker.introduction))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.showCommunity) ? _c('Fancybox', {
    on: {
      "close": function($event) {
        _vm.showCommunity = false
      }
    }
  }, [_c('div', {
    staticClass: "btn-close",
    on: {
      "click": function($event) {
        _vm.showCommunity = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("社群闖關")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("社群闖關邀請到許多資訊相關社群前來擺攤，藉由互動遊戲、影片欣賞、專人介紹...等方式，讓學員認識所謂「社群」，並對開源活動有初步了解。 ")]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("邀請社群")]), _vm._v(" "), _c('ul', {
    staticClass: "community"
  }, _vm._l((_vm.communities), function(community, index) {
    return _c('li', {
      key: index
    }, [_c('h2', {
      staticClass: "subTitle"
    }, [_vm._v(_vm._s(community.name))]), _vm._v(" "), _c('div', [(community.img.length > 0) ? _c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": './static/communities/' + community.img,
        "alt": community.name
      }
    })]) : _vm._e(), _vm._v(" "), _vm._l((community.introduction), function(paragraph, index) {
      return _c('p', {
        key: index,
        staticClass: "content"
      }, [_vm._v(_vm._s(paragraph))])
    })], 2)])
  }))]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("Day 1")]), _vm._v(" "), _c('td', [_vm._v("Day 2")]), _vm._v(" "), _c('td', [_vm._v("Day 3")]), _vm._v(" "), _c('td', [_vm._v("Day 4")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('p', [_vm._v("07:00\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("07:30")])]), _vm._v(" "), _c('td', {
    staticClass: "common",
    attrs: {
      "rowspan": "3"
    }
  }, [_c('p', [_vm._v("傳送門已開啟")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("移動")])]), _vm._v(" "), _c('td', {
    staticClass: "common"
  }, [_c('p', [_vm._v("迎接太陽之光")])]), _vm._v(" "), _c('td', {
    staticClass: "common"
  }, [_c('p', [_vm._v("自我升級完成")])]), _vm._v(" "), _c('td', {
    staticClass: "common",
    attrs: {
      "rowspan": "3"
    }
  }, [_c('p', [_vm._v("養精蓄銳")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('p', [_vm._v("07:30\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("09:00")])]), _vm._v(" "), _c('td', {
    staticClass: "activity",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('p', [_vm._v("陌生人的禮物")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("Bot Game")])]), _vm._v(" "), _c('td', {
    staticClass: "activity",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('p', [_vm._v("奇妙際遇")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('p', [_vm._v("09:00\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("09:30")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('p', [_vm._v("09:30\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("10:00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "activity"
  }, [_c('p', [_vm._v("學院的號召")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("集合 ＆ 報到")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "activity",
    attrs: {
      "rowspan": "3"
    }
  }, [_c('p', [_vm._v("榮耀的盡頭")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("\n            黑客松\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('p', [_vm._v("10:00\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("10:30")])]), _vm._v(" "), _c('td', {
    staticClass: "activity",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('p', [_vm._v("迎接新世界")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("開幕")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('p', [_vm._v("10:30\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("11:00")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('p', [_vm._v("11:00\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("11:30")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "activity",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('p', [_vm._v("新的邂逅")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("破冰活動")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('p', [_vm._v("11:30\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("12:00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('p', [_vm._v("12:00\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("13:30")])]), _vm._v(" "), _c('td', {
    staticClass: "common",
    attrs: {
      "colspan": "4"
    }
  }, [_c('p', {
    staticClass: "sub"
  }, [_vm._v("午餐")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('p', [_vm._v("13:30\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("15:30")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "activity"
  }, [_c('p', [_vm._v("黃金的光輝")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("黑客松發表")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('p', [_vm._v("15:30\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("16:30")])]), _vm._v(" "), _c('td', {
    staticClass: "activity",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('p', [_vm._v("一切的真相")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("閉幕")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('p', [_vm._v("16:30\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("17:00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "common"
  }, [_c('p', [_vm._v("尋找自我")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('p', [_vm._v("17:00\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("18:00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "common"
  }, [_c('p', [_vm._v("與市長的會面")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("晚餐")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "common",
    attrs: {
      "rowspan": "5"
    }
  }, [_c('p', [_vm._v("無悔的選擇")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("返家")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('p', [_vm._v("18:00\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("19:00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "activity",
    attrs: {
      "rowspan": "3"
    }
  }, [_c('p', [_vm._v("無法逃離的背叛")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('p', [_vm._v("19:00\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("20:00")])]), _vm._v(" "), _c('td', {
    staticClass: "common"
  }, [_c('p', [_vm._v("謀略之夜")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("晚餐")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('p', [_vm._v("20:00\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("21:00")])]), _vm._v(" "), _c('td', {
    staticClass: "activity",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('p', [_vm._v("突擊")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("黑客松")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('p', [_vm._v("21:00\n            "), _c('br'), _vm._v("~\n            "), _c('br'), _vm._v("22:00")])]), _vm._v(" "), _c('td', {
    staticClass: "common"
  }, [_c('p', [_vm._v("絕望中的微微亮光")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("宵夜")])]), _vm._v(" "), _c('td', {
    staticClass: "activity"
  }, [_c('p', [_vm._v("謊言與真相")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("神秘活動＆宵夜")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("今年夏令營有別於往年的單一教學方式，而是在不影響一般課程的情況，安排一些廣度課程，讓學員在學習基礎課程之餘，也能學到資訊領域的其他層面，增加自身資訊技能的廣度。 除基礎課程與廣度課程外，我們也邀請到許多在資訊領域打滾多年的人士分享自身經驗，期許迷茫中的學員，可以點燃未來的一盞明燈，在資訊道路上有前進的動力及方向。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("社群闖關邀請到許多資訊相關社群前來擺攤，藉由互動遊戲、影片欣賞、專人介紹...等方式，讓學員認識所謂「社群」，並對開源活動有初步了解。點選課表可檢視詳細的社群資訊。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("視界咖啡館參考自世界咖啡館（The World Café），在本次夏令營中，我們邀請到各領域及社群前輩，將傳統座談會形式改以小組討論的樣貌呈現，並與學員分享工作經驗、學習過程、面對困難的解決方式或希望給予 SITCON 夏令營學員的建議，提出值得學員思考、了解的觀點。期望透過縮短講師及學員間的距離，鼓勵學員踴躍提問、參與，進而產生良好的雙向交流。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("黑客松（Hackathon）是「黑客」（Hack；原指早期為電腦系統找尋不完美的地方，或是探索不同的解法，來改善電腦系統）跟「馬拉松」（Marathon）的組合字，顧名思義，也就像是程式設計、工程界的馬拉松。由有興趣的一群人在有限的時間內，發揮自己的專長做出一個有特色的專案。")]), _vm._v(" "), _c('p', [_vm._v("今年， SITCON 夏令營將為學員打造一場專屬的小型黑客松，取代傳統的晚會、唱歌跳舞等活動，以小隊為單位，在吃吃喝喝的同時，一起發揮創意、運用課程中所學，做出與眾不同的作品呈現！")])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "fancyBox"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default")], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('banner'), _vm._v(" "), _c('about'), _vm._v(" "), _c('course'), _vm._v(" "), _c('admission'), _vm._v(" "), _c('registration'), _vm._v(" "), _c('organizer'), _vm._v(" "), _c('staff'), _vm._v(" "), _c('exp'), _vm._v(" "), _c('coc'), _vm._v(" "), _c('footers')], 1)
},staticRenderFns: []}

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container",
    attrs: {
      "id": "admission"
    }
  }, [_c('h1', {
    staticClass: "title fourtitle"
  }, [_vm._v("錄取名單")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle redcar"
  }, [_vm._v("正取學員")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "admissionList"
  }, _vm._l((_vm.admissionList), function(student, index) {
    return _c('li', {
      key: index
    }, [_vm._v("\n        " + _vm._s(student) + "\n      ")])
  }))]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle bluecar"
  }, [_vm._v("備取學員")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "admissionList"
  }, _vm._l((_vm.waiting), function(student, index) {
    return _c('li', {
      key: index
    }, [_vm._v("\n        " + _vm._s(student) + "\n      ")])
  }))]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle redcar"
  }, [_vm._v("繳費時間")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', {
    staticClass: "subtitle bluecar"
  }, [_vm._v("中途離營與退費規則")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', {
    staticClass: "subtitle redcar"
  }, [_vm._v("注意事項")]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("即日起至 2017 / 06 / 25 止")]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("可選擇之繳費方式包含："), _c('br'), _vm._v("超商代碼/條碼、webATM、ATM轉帳")]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("請透過錄取通知中的連結進行第二階段報名後，取得相關繳費資料再繳費。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("如需於 SITCON 夏令營期間中途離營，未滿 20 歲之學員需要由法定監護人簽署暫時 / 提前離營家長同意書；年滿 20 歲之學員需簽署暫時 / 提前離營切結書，旨在保障學員離營期間會注意自身安全，營隊將不負責學員離營後之安全事宜。")]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("相關退費規則如下：")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("退費申請日距活動開始前 30 日，實繳金額扣除必要之行政手續費用 200 元後剩餘款項返還。")]), _vm._v(" "), _c('li', [_vm._v("退費申請日距活動開始前 21 - 29 日，扣除實繳金額之 10% 後，剩餘 90% 返還。")]), _vm._v(" "), _c('li', [_vm._v("退費申請日距活動開始前 15 - 20 日，扣除實繳金額之 30% 後，剩餘 70% 返還。")]), _vm._v(" "), _c('li', [_vm._v("退費申請日距活動開始前 8 - 14 日，扣除實繳金額之 50% 後，剩餘 50% 返還。")]), _vm._v(" "), _c('li', [_vm._v("退費申請日距活動開始前 7 日(含）內，不受理退費申請。")]), _vm._v(" "), _c('li', [_vm._v("在營期間若違反 CoC 規範，經 SITCON 夏令營團隊決議由監護人帶離營隊，亦不退還已繳交之報名費用。")]), _vm._v(" "), _c('li', [_vm._v("若因不可抗力之因素，將扣除營服以及相關必要費用，再按照活動參加天數比例扣除報名費用後全數返還。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('ol', [_c('li', [_vm._v("\n        第二階段報名連結已連同錄取通知寄發至前一次報名所留下之電子信箱，請正取學員至您的信箱查閱信件。\n      ")]), _vm._v(" "), _c('li', [_vm._v("請於第二階段報名系統正確選擇您的票種，若票種與報名身份不符（如個人報名卻選擇團體報名），將需透過匯款方式補繳報名費用，否則視將同放棄資格。")]), _vm._v(" "), _c('li', [_vm._v("正取學員資格不得轉讓予他人使用，轉讓者將取消資格。")]), _vm._v(" "), _c('li', [_vm._v("繳費完成始完成報名程序，正取學員若未於期限內繳交報名費用，將取消資格，由備取者遞補。")]), _vm._v(" "), _c('li', [_vm._v("錄取通知以及行前注意等資訊，均將透過報名時所留下之電子郵件通知學員，請務必定期檢查信箱，以確保個人權益。")]), _vm._v(" "), _c('li', [_vm._v("有任何問題歡迎來信至\n        "), _c('a', {
    attrs: {
      "href": "mailto:ask@sitcon.camp"
    }
  }, [_vm._v("ask@sitcon.camp")]), _vm._v("，我們將儘速回覆您。")])])])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container",
    attrs: {
      "id": "exp"
    }
  }, [_c('h1', {
    staticClass: "title fourtitle"
  }, [_vm._v("學員心得")]), _vm._v(" "), _c('article', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "subtitle bluecar"
  }, [_vm._v("學員：藍藍路")]), _vm._v(" "), _c('p', [_vm._v("去年被朋友洗腦就跳進了這個無底洞oωo 本身是資訊新手，不過課程不會深到要有多厚的底子才會懂。營隊裡面有個機制是蒐集點數，常常只要達成某個日常小任務就可以拿到。點數可以在黑客松的時候換零食＆在最後的閉幕換奇怪的禮物ww在黑客松中大家一起分工（熬夜）做出成品的時候真的蠻感動的，好像體驗到了工程師的生活，卻感到特別溫馨XD整隊就像一個小家庭，各種互助OAO")]), _vm._v(" "), _c('p', [_vm._v("參加這個夏令營能帶走的或許不是各種專業的技術，但真的可以學到不少經驗。想入坑的快來參加今年的營隊r ٩(๑•̀ω•́๑)۶")])]), _vm._v(" "), _c('article', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "subtitle redcar"
  }, [_vm._v("學員：Pin Lin")]), _vm._v(" "), _c('p', [_vm._v("去年暑假被朋友推入了 SITCON 開源鄉，做了四天三夜的夢—在夢中我參加了一個由對資訊技術有興趣、想讓更多人認識開源的人們籌辦的夏令營。然而，這跟普通的大學營隊很不一樣，活動與課程的適當搭配讓我在體驗活動的同時一邊學習：共同課程的 Git 讓我得以把自己的程式碼上傳到 GitHub，讓我感受到開源界的互助精神，能向世界貢獻出自己的程式碼也讓我感到異常的興奮；雙軌課程中的前端學員跟後端學員合作，在最後的黑客松一起合作產出最後的成品，讓我體會到團隊合作可以讓一件事變得不再艱難。過程中看見了每個鄉民的真心投入，真的讓我十分的感動，心中彷彿也多了一股對開源鄉的認同感。要是下次在路上又看見通往開源鄉的坑，我一定會毫不猶豫把我的朋友通通推進去。")])])])
}]}

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    attrs: {
      "id": "banner"
    }
  }, [_c('div', {
    attrs: {
      "id": "osc-logo"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button center"
  }, [_c('a', {
    attrs: {
      "href": "#admission"
    },
    on: {
      "click": function($event) {
        _vm.admission()
      }
    }
  }, [_vm._v("錄取名單")])])]), _vm._v(" "), _c('navbar')], 1)
},staticRenderFns: []}

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('p', [_vm._v("SITCON 學生計算機年會 / SITCON 夏令營")])])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container",
    attrs: {
      "id": "registration"
    }
  }, [_c('h1', {
    staticClass: "title twotitle reversetitle"
  }, [_vm._v("報名")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle redcar"
  }, [_vm._v("活動費用")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("個人報名： 6500 元 / 人")]), _vm._v(" "), _c('li', [_vm._v("\n        團體報名： 5900 元 / 人\n        "), _c('br'), _vm._v(" 三人同時報名，視為團體報名，每團以三人為限，請詳閱\n        "), _c('a', {
    attrs: {
      "href": "./assets/document/SITCON_camp_2017_Registration_brochure.pdf",
      "target": "_blank"
    }
  }, [_vm._v("活動報名簡章")]), _vm._v("。\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        本次夏令營招收學員 60 名，我們會針對報名資料做簡易審查，非先報先贏。\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        正取學員名單將於 2017 / 06 / 15 公佈，正取學員需完成報名費繳交，始完成報名程序。\n      ")]), _vm._v(" "), _c('li', [_vm._v("另設有補助名額，請詳閱\n        "), _c('a', {
    attrs: {
      "href": "./assets/document/SITCON_camp_2017_Registration_fee_reduction.pdf",
      "target": "_blank"
    }
  }, [_vm._v("補助辦法")]), _vm._v("。")])]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle bluecar"
  }, [_vm._v("報名時間")]), _vm._v(" "), _c('p', {
    staticClass: "info center"
  }, [_c('del', [_vm._v("即日起至 2017 / 06 / 05 止")])]), _vm._v(" "), _c('p', {
    staticClass: "info center"
  }, [_c('del', [_vm._v("好評再度加開，延長至 2017 / 06 / 12 止")])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "button"
  }, [_vm._v("已結束報名")])])]), _vm._v(" "), _c('div', {
    staticClass: "content row separate-around wrap"
  }, [_c('div', {
    staticClass: "items"
  }, [_c('h2', {
    staticClass: "subtitle redcar"
  }, [_vm._v("活動時間")]), _vm._v(" "), _c('p', {
    staticClass: "info center"
  }, [_vm._v("8/14（一）~ 8/17（四）")])]), _vm._v(" "), _c('div', {
    staticClass: "items"
  }, [_c('h2', {
    staticClass: "subtitle bluecar"
  }, [_vm._v("活動地點")]), _vm._v(" "), _c('p', {
    staticClass: "info center"
  }, [_vm._v("東海大學")]), _vm._v(" "), _c('p', {
    staticClass: "info center"
  }, [_vm._v("台中市西屯區台灣大道四段1727號")])])]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle redcar"
  }, [_vm._v("注意事項")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("\n      本次活動採用 KKTIX 售票進行報名，請詳細閱讀\n      "), _c('a', {
    attrs: {
      "href": "./assets/document/SITCON_camp_2017_Registration_brochure.pdf",
      "target": "_blank"
    }
  }, [_vm._v("活動報名簡章")]), _vm._v("。\n    ")]), _vm._v(" "), _c('li', [_vm._v("正式取得學員資格後不得轉讓予他人使用，轉讓者將取消資格。")]), _vm._v(" "), _c('li', [_vm._v("繳費完成始完成報名程序，正取學員若未於期限內繳交報名費用，將取消資格，由備取者遞補。")]), _vm._v(" "), _c('li', [_vm._v("錄取通知以及行前注意等資訊，均將透過報名時所留下之電子郵件通知學員，請務必定期檢查信箱，以確保個人權益。")]), _vm._v(" "), _c('li', [_vm._v("團體報名不保證所有團員皆錄取，唯團報經錄取者，皆可享有團體報名優惠。")]), _vm._v(" "), _c('li', [_vm._v("有任何問題歡迎來信至\n      "), _c('a', {
    attrs: {
      "href": "mailto:ask@sitcon.camp"
    }
  }, [_vm._v("ask@sitcon.camp")]), _vm._v("，我們將儘速回覆您。")])])])
}]}

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container",
    attrs: {
      "id": "about"
    }
  }, [_c('h1', {
    staticClass: "title sixtitle reversetitle longTitle"
  }, [_vm._v("關於 SITCON 夏令營")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("資訊領域逐漸成為科技時代的重要學門，社群與開源精神亦持續抬頭，SITCON 認為將資訊教育向下扎根，播灑開源種子，為在資訊科學領域有興趣的學生提供一個親切而良好的入門機會是一件十分重要的事情。")]), _vm._v(" "), _c('p', [_vm._v("2014年迄今，SITCON 夏令營已邁入第四屆，前幾年營隊的課程涵蓋了許多不同的程式語言及知識，除了課程之外，我們更設計了社群闖關、視界咖啡館、黑客松等豐富活動，讓學員能充分吸收新知、尋找自己的愛好及興趣，進而加入我們一起推動 Open Source。")]), _vm._v(" "), _c('p', [_vm._v("今年我們將營隊拉到台中，於東海大學舉辦 SITCON 夏令營，營期間將帶各位進入 SITCON 開源城，以「踏入資訊域，放眼開源界」為主軸去設計豐富且多元的課程，其中將會有實際學習 Python 語言，並進一步自製聊天機器人的實作課程，也有讓學員認識社群精神、開源文化、資訊安全等廣度課程；除了課程之外，我們也會為學員帶來前段提到的精彩活動，絕對能讓每一個人大開眼界。開源城藏著許許多多的驚喜，期待著各位學員進入我們的城市探險，挖掘出屬於你們的資訊寶藏。")])]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("適合參加族群")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("本次夏令營適合參加的族群為涉入資訊領域未深的學生，今年課程有別於往年，我們降低課程難度，採用適合新手的Python 程式語言，透過結合生活中時常接觸的通訊軟體，讓對資訊有興趣的學員，在參加完夏令營後可以學到基礎的程式設計，藉此打開通往資訊領域的大門。")]), _vm._v(" "), _c('p', [_vm._v("由於我們招收的族群主要是學生，故營期內也會邀請知名人士分享自身一路走來的故事，並讓學員有機會和這些平時較難接觸到的人近距離交談，期望學員在學習技術之餘，也能點燃指引未來的明燈。")])]), _vm._v(" "), _c('h1', {
    staticClass: "title sixtitle"
  }, [_vm._v("關於 SITCON")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("2012 年中，一群學生在社群浪潮中為相同的理想聚集，秉持「以學生為本、由學生自發舉辦」的核心理念，SITCON 學生計算機年會及同名社群自 2013 年起，陸續舉行年會、定期聚、黑客松、工作坊、夏令營與多場演講，於技術交流之餘，亦在推廣資訊及開源教育上不遺餘力，希望透過技術與知識的激盪，給予學生們一個用自身力量實踐夢想的舞台。")])])])
}]}

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container",
    attrs: {
      "id": "coc"
    }
  }, [_c('h1', {
    staticClass: "title fourtitle reversetitle"
  }, [_vm._v("行為準則")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("SITCON 夏令營期許成為年輕學子踏入資訊世界的引路人，同時我們也致力於為每位成員提供更友善、開放的環境。相信每位進入 SITCON 夏令營的學員及夥伴都值得被尊重，而我們亦將盡力提供最安全的環境，讓參與 SITCON夏令營的每個人能夠尊重個體間的差異、在社群中相互扶助、並鼓勵所有人揮灑屬於自己的生命色彩。因此，若有幸能在 SITCON 夏令營與您見面，無論您是以學員、贊助商、工作人員、或是講者的身份參加，我們都希望您配合。")]), _vm._v(" "), _c('p', [_vm._v("請遵守以下規則：")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("尊重每一位參與者，將對方的感受放在心上。")]), _vm._v(" "), _c('li', [_vm._v("避免使用帶有侮辱、歧視、或具有潛在騷擾意涵的言語及手勢。")]), _vm._v(" "), _c('li', [_vm._v("多關心周遭的所有同伴，適度詢問對方是否需要協助。")]), _vm._v(" "), _c('li', [_vm._v("當遭遇危險、或發現事情不對勁時，適時尋求工作人員的支援與協助。")]), _vm._v(" "), _c('li', [_vm._v("在夏令營裡多交朋友，珍惜彼此相聚的時光！")])]), _vm._v(" "), _c('p', [_vm._v("以下的行為是不被容忍的：")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("針對性別、性向、種族、外貌、宗教、年齡、身體狀況或個人身份的挑釁或冒犯。")]), _vm._v(" "), _c('li', [_vm._v("任何形式的性騷擾、言語及肢體霸凌。")]), _vm._v(" "), _c('li', [_vm._v("公開發表、展示或放映含有侮辱、歧視、仇恨、暴力、或是性暗示的言論、影像、或錄影。")]), _vm._v(" "), _c('li', [_vm._v("無故干擾課程、議程或活動的正常進行，無視工作人員或他人的制止。")]), _vm._v(" "), _c('li', [_vm._v("干擾、攻擊現場提供之網路，未經同意側錄封包或散佈隱私資訊。")]), _vm._v(" "), _c('li', [_vm._v("任何違反法律的行為。")])]), _vm._v(" "), _c('p', [_vm._v("為了確保每位參與者的安全，我們將恪守以上規則。對於違反行為準則者，我們將採取必要且合理的手段予以介入，包含但不限於將參與者請離現場、自相關名冊除名或列為不受歡迎對象，或在必要時移送警察機關法辦。若您或他人遇到了以上情況、或是有任何其他顧慮，都請立即尋求 SITCON 夏令營工作人員的協助。我們誠摯的邀請來到 SITCON 夏令營的朋友一同履行以上承諾，將 SITCON 夏令營打造為更友善、溫暖的所在；讓每一位參與者，都能在夏令營的活動和相處中共同成長、在人與人的互動中找到自信⸺而這正是我們所珍惜、試圖給予所有學員的，屬於學生社群的真正精神。")])])])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    attrs: {
      "id": "navbar"
    }
  }, [_c('div', {
    staticClass: "toggle"
  }, [_c('a', {
    staticClass: "center",
    attrs: {
      "href": "#navbar"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('span', {
    staticClass: "icon"
  }), _c('h1', {
    staticClass: "text"
  }, [_vm._v("Menu")])])]), _vm._v(" "), _c('ul', {
    staticClass: "center"
  }, [_c('li', [_c('a', {
    staticClass: "center",
    attrs: {
      "href": "#banner",
      "data-target": "#banner"
    },
    on: {
      "click": _vm.jumpTo
    }
  }, [_c('div', {
    staticClass: "icon",
    attrs: {
      "data-target": "#banner"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#about",
      "data-target": "#about"
    },
    on: {
      "click": _vm.jumpTo
    }
  }, [_vm._v("關於")])]), _vm._v(" "), _c('li', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#course",
      "data-target": "#course"
    },
    on: {
      "click": _vm.jumpTo
    }
  }, [_vm._v("課程")])]), _vm._v(" "), _c('li', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#admission",
      "data-target": "#admission"
    },
    on: {
      "click": _vm.jumpTo
    }
  }, [_vm._v("錄取")])]), _vm._v(" "), _c('li', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#registration",
      "data-target": "#registration"
    },
    on: {
      "click": _vm.jumpTo
    }
  }, [_vm._v("報名")])]), _vm._v(" "), _c('li', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#organizer",
      "data-target": "#organizer"
    },
    on: {
      "click": _vm.jumpTo
    }
  }, [_vm._v("共同主辦")])]), _vm._v(" "), _c('li', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#staff",
      "data-target": "#staff"
    },
    on: {
      "click": _vm.jumpTo
    }
  }, [_vm._v("工作團隊")])]), _vm._v(" "), _c('li', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#exp",
      "data-target": "#exp"
    },
    on: {
      "click": _vm.jumpTo
    }
  }, [_vm._v("學員心得")])]), _vm._v(" "), _c('li', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#coc",
      "data-target": "#coc"
    },
    on: {
      "click": _vm.jumpTo
    }
  }, [_vm._v("行為準則")])])])])
},staticRenderFns: []}

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container",
    attrs: {
      "id": "staff"
    }
  }, [_c('h1', {
    staticClass: "title fourtitle reversetitle"
  }, [_vm._v("工作團隊")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._l((_vm.staffs), function(team) {
    return [_c('p', {
      staticClass: "teamMember"
    }, [_c('span', {
      staticClass: "teamName"
    }, [_vm._v(_vm._s(team.name) + " ")]), _c('br'), _vm._v(_vm._s(team.users.map(function (el) { return el.display_name; }).join('、')))])]
  })], 2)])
},staticRenderFns: []}

/***/ })
],[30]);


// WEBPACK FOOTER //
// static/js/app.f61b0c0a73cc87598259.js